const consent = {
  title: "ประกันอุบัติเหตุ",
  description: `แฮปปี้สุดๆ ชีวิตนี้ไม่มีสะดุด, รับประกันตั้งแต่อายุ 16 – 65 ปี, คุ้มครองสูงสุด 2,000,000 บาท, คุ้มครองทุกที่ ทุกเวลา, รับเงินชดเชยรายได้กรณีรักษาตัวเป็นผู้ป่วยในโรงพยาบาล, ไม่ต้องสำรองจ่ายกับโรงพยาบาลคู่สัญญาของบริษัทฯ กว่า 345 แห่ง ทั่วประเทศ`,
  benefits: [
    {
      title: "แผนรายเดี่ยว",
      detail: "ความคุ้มครอง",
      items: [
        {
          index:
            "1. การเสียชีวิต สูญเสียอวัยวะ สายตา หรือทุพพลภาพถาวรสิ้นเชิง (อบ.1) <br/> (ไม่รวมการถูกฆาตกรรมหรือทำร้ายร่างกาย)",
          ranges: [
            {
              name: "วงเงินคุ้มครอง (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "300,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "500,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000,000",
                },
              ],
            },
          ],
        },
        {
          index:
            "2. การเสียชีวิต สูญเสียอวัยวะ สายตา หรือทุพพลภาพถาวรสิ้นเชิง (อบ.1) <br/> จากการถูกฆาตกรรมหรือทำร้ายร่างกาย",
          ranges: [
            {
              name: "วงเงินคุ้มครอง (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "150,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "250,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "500,000",
                },
              ],
            },
          ],
        },
        {
          index:
            "3. การเสียชีวิต สูญเสียอวัยวะ สายตา หรือทุพพลภาพถาวรสิ้นเชิง (อบ.1) <br/> จากการขับขี่/โดยสารรถจักรยานยนต์",
          ranges: [
            {
              name: "วงเงินคุ้มครอง (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "150,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "250,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "500,000",
                },
              ],
            },
          ],
        },
        {
          index:
            "4. การเสียชีวิต สูญเสียอวัยวะ สายตา หรือทุพพลภาพถาวรสิ้นเชิง (อบ.1) จากการก่อการร้าย",
          ranges: [
            {
              name: "วงเงินคุ้มครอง (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "150,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "250,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "500,000",
                },
              ],
            },
          ],
        },
        {
          index:
            "5. การเสียชีวิต สูญเสียอวัยวะ สายตา หรือทุพพลภาพถาวรสิ้นเชิง (อบ.1) จากอุบัติเหตุสาธารณะ",
          ranges: [
            {
              name: "วงเงินคุ้มครอง (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "600,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "1,000,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "2,000,000",
                },
              ],
            },
          ],
        },
        {
          index:
            "6. การรักษาพยาบาล ต่ออุบัติเหตุแต่ละครั้ง <br/>  (รวมการขับขี่/โดยสารรถจักรยานยนต์ และการถูกฆาตกรรมหรือถูกทำร้าย และการก่อการร้าย)",
          ranges: [
            {
              name: "วงเงินคุ้มครอง (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "15,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "25,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "50,000",
                },
              ],
            },
          ],
        },
        {
          index:
            "7. เงินชดเชยรายได้รายวันกรณีรักษาตัวเป็นผู้ป่วยในโรงพยาบาลสูงสุด 365 วันต่ออุบัติเหตุแต่ละครั้ง (รวมการขับขี่/โดยสารรถจักรยานยนต์การถูกฆาตกรรมหรือถูกทำร้ายและการก่อการร้าย)",
          ranges: [
            {
              name: "วงเงินคุ้มครอง (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "300",
                },
                {
                  name: "แบบที่ 2",
                  price: "500",
                },
                {
                  name: "แบบที่ 3",
                  price: "1,000",
                },
              ],
            },
          ],
        },
        {
          index:
            "8. ค่าปลงศพและค่าใช้จ่ายในการจัดการงานศพกรณีเสียชีวิตจากการบาดเจ็บหรือการเจ็บป่วย <br/> (ระยะเวลารอคอยจากการเจ็บป่วย 180 วัน) <br/> (รวมการขับขี่/โดยสารรถจักรยานยนต์ การถูกฆาตกรรมหรือถูกทำร้าย และการก่อการร้าย)",
          ranges: [
            {
              name: "วงเงินคุ้มครอง (บาท)",
              plans: [
                {
                  name: "แบบที่ 1",
                  price: "10,000",
                },
                {
                  name: "แบบที่ 2",
                  price: "10,000",
                },
                {
                  name: "แบบที่ 3",
                  price: "10,000",
                },
              ],
            },
          ],
        },
      ],
      timesHeaders: ["แบบที่ 1", "แบบที่ 2", "แบบที่ 3"],
      times: [
        {
          age: "16 - 65 ปี",
          fee: {
            "แบบที่ 1": 1580,
            "แบบที่ 2": 2080,
            "แบบที่ 3": 2980,
          },
          stamp: {
            "แบบที่ 1": 20,
            "แบบที่ 2": 20,
            "แบบที่ 3": 20,
          },
          total: {
            "แบบที่ 1": 1600,
            "แบบที่ 2": 2100,
            "แบบที่ 3": 3000,
          },
        }
      ],
    },
  ],
  conditions: [
    {
      title: "",
      detail: "เงื่อนไขการรับประกันภัย",
      items: [
        {
          index:
            "1. ผู้เอาประกันต้องมีอายุระหว่าง 16 – 65 ปี (ต่ออายุได้ถึง70 ปี) โดยใช้ปีเกิดเทียบกับปีที่ตกลงทำประกันภัย",
        },
        {
          index:
            "2. ไม่รับประกันอาชีพเสี่ยง (อาชีพชั้น 3 และ4) ดังนี้ พนักงานส่งเอกสาร พนักงานขับรถ มอเตอร์ไซค์รับจ้าง กรรมกร คนงาน คนงานเหมือง ยาม หนุ่มโรงงาน สาวโรงงาน เกษตรกร ชาวประมง พนักงานติดตั้งเสาอากาศ ช่างต่างๆ (เช่น ช่างปูน ช่างไม้ ช่างซ่อมไฟฟ้า ช่างประปา ช่างซ่อมรถยนต์) พนักงานต้อนรับบนรถ เรือ หรือเครื่องบิน เป็นต้น",
        },
        {
          index: "3. รับประกันภัยทั้งคนไทยและต่างชาติ",
        },
        {
          index: "4. รับประกันชาวต่างชาติ และต่างด้าว เฉพาะที่มี Passport",
        },
        {
          index:
            "5. จำนวนกรมธรรม์สูงสุด/คน : ผู้เอาประกันภัย 1 คน สามารถทำประกันได้ 1 ฉบับเท่านั้น",
        },
      ],
    },
  ],
  exceptions: [
    {
      title: "",
      detail: "หมายเหตุ",
      items: [
        {
          index: "1. เงื่อนไขความคุ้มครองและข้อยกเว้นเป็นไปตามกรมธรรม์",
        },
        {
          index:
            "2. ผู้ซื้อควรทำความเข้าใจในรายละเอียดความคุ้มครองและเงื่อนไขก่อนตัดสินใจทำประกันภัย",
        },
      ],
    },
  ],
  services: [
    {
      title: "",
      detail: "ศูนย์บริการลูกค้า (Customer Service Center)",
      items: [
        {
          index: "<li> ทาง Call Center โทร.1484",
        },
      ],
    },
  ],
};

export default consent;
